import React, { Suspense, lazy, useState } from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { CartProvider } from '../context/CartContext';
import StickyCartFooter from './StickyCartFooter';
import '../index.css';
import LoadingAnimation from './LoadingAnimation';
import CartDrawer from './CartDrawer';
import whatsappIcon from '../assets/whatsapp.png';
import telephoneIcon from '../assets/telephone.png';
import quickPurchaseImage from '../assets/quickpurchase.png';


const HomePage = lazy(() => import('../pages/HomePage'));
const ProductsPage = lazy(() => import('../pages/ProductsPage'));
const ProductDetailsPage = lazy(() => import('../pages/ProductDetailsPage'));
const QuickBuyPage = lazy(() => import('../pages/QuickBuyPage'));
const CartPage = lazy(() => import('../pages/CartPage'));
const CheckoutPage = lazy(() => import('../pages/CheckoutPage'));
const WholesalePage = lazy(() => import('../pages/WholesalePage'));
const AboutUsPage = lazy(() => import('../pages/AboutUsPage'));
const ContactUsPage = lazy(() => import('../pages/ContactUsPage'));
const OrderSuccessPage = lazy(() => import('../pages/OrderSuccessPage'));
const CategoriesPage = lazy(() => import('../pages/CategoriesPage'));
const QuotationPage = lazy(() => import('../pages/QuotationPage')); // புதிய QuotationPage-ஐ இங்கே இறக்குமதி செய்கிறோம்

const AppContent = () => {
    const location = useLocation();
    const [isCartDrawerOpen, setIsCartDrawerOpen] = useState(false);

    const handleOpenCartDrawer = () => {
        setIsCartDrawerOpen(true);
    };

    const handleCloseCartDrawer = () => {
        setIsCartDrawerOpen(false);
    };

    return (
        <CartProvider>
            {/* This div adds a colorful, glowing background for a creative look across all pages */}
            <div className="festive-background-glow"></div>
            <div className="flex flex-col min-h-screen">
                <Header onCartClick={handleOpenCartDrawer} />
                {/* Add padding-bottom to prevent content from being hidden by the sticky footer */}
                <main className="flex-grow pb-32">
                    <Suspense fallback={<LoadingAnimation />}>
                        <Routes>
                            <Route path="/" element={<HomePage />} />
                            <Route path="/products" element={<ProductsPage />} />
                            <Route path="/products/:id" element={<ProductDetailsPage />} />
                            <Route path="/quick-buy" element={<QuickBuyPage />} />
                            <Route path="/cart" element={<CartPage />} />
                            <Route path="/checkout" element={<CheckoutPage />} />
                            <Route path="/wholesale" element={<WholesalePage />} />
                            <Route path="/about-us" element={<AboutUsPage />} />
                            <Route path="/contact-us" element={<ContactUsPage />} />
                            <Route path="/categories" element={<CategoriesPage />} />
                            <Route path="/quotation" element={<QuotationPage />} /> {/* புதிய Route இங்கே சேர்க்கப்பட்டுள்ளது */}
                            <Route path="/order-success/:orderId" element={<OrderSuccessPage />} />
                        </Routes>
                    </Suspense>
                </main>
                <StickyCartFooter />
            </div>

            {location.pathname !== '/quick-buy' && (
                <div className="fixed right-4 z-50 bottom-[20%] md:bottom-[35%]">
                    <Link to="/quick-buy" className="blink-animation">
                        <img src={quickPurchaseImage} alt="Order Now" className="w-24 md:w-32" />
                    </Link>
                </div>
            )}

            <CartDrawer isOpen={isCartDrawerOpen} onClose={handleCloseCartDrawer} />
        </CartProvider>
    );
};

export default AppContent;